import React from 'react'
import styled from '@emotion/styled'
import {css} from '@emotion/core'

import GoodPrice from '../GoodPrice'
import Button from '../../form/Button'
import {calcDiscount} from '../../../../universal-src/model/goods'
import {GoodPropsIcons} from '../GoodPropsList'

const chooseByLayout = (layout, variants) => variants[layout]

const Root = styled.div`
  display: flex;
  align-items: center;
  ${({layout}) => chooseByLayout(layout, { 
    normal: css`
      flex-direction: row;
    `,
    small: css`
      flex-direction: row;
    `,
    vertical: css`
      flex-direction: column;
    `
  })}
`

const PriceBin = styled.div`
  ${({layout}) => chooseByLayout(layout, {
    normal: css`
      margin-right: 33px;
    `,
    small: css`
      margin-right: 15px;
    `,
    vertical: css`
      display: flex;
      align-items: flex-end;
      justify-content: center;
      height: 35px;
    `,
  })}
`

const PriceAndIcons = styled.div`
  display: flex;
  align-items: center;
`

const BuySectionBin = styled.div`
  ${({layout}) => chooseByLayout(layout, {
    normal: css`
      width: 175px;
      min-height: 40px;    
      text-align: right;
    `,
    small: css`
      display: flex;
      width: 170px;
      min-height: 30px;
      align-items: center;
      justify-content: flex-end;
      text-align: right;
    `,
    vertical: css`
      display: flex;
      margin-top: 5px;
      min-height: 30px;
      align-items: center;
      justify-content: center;
    `,
  })}
`

const Restriction = styled.div`
  font-family: raleway, sans-serif;
  line-height: 1.3;
  font-weight: 500;
  color: #333;
  ${({layout}) => chooseByLayout(layout, {
    normal: css`
      font-size 12px;
    `,
    small: css`
      font-size 10px;
    `,
    vertical: css`
      font-size 10px;
      text-align: center;
    `,
  })}
`

const RestrictionTitle = styled.div`
  color: #e61818;
  font-size: ${({size}) => size === 'normal' ? '9px' : '8px'};
  font-weight: 600;
  text-transform: uppercase;
`

const QuantityControl = styled.div`
  text-align: right;
  font-family: Merriweather, serif;
  font-weight: 500;
  ${({size}) => size === 'normal' 
    ? css`
      font-size: 15px;
      line-height: 1.7;
      color: rgba(0, 0, 0, 0.8);
    ` : css`
      font-size: 12px;
      line-height: 1.3;
      color: rgba(0, 0, 0, 0.9);
    `
  }
  font-style: italic;
`

const Input = styled.input`
  margin-left: 5px;
  border: 0 solid #ccc;
  border-radius: 0;
  border-bottom-width: 2px;
  padding: 4px 0 4px 4px;
  box-sizing: border-box;
  color: #000;
  text-align: center;
  transition: border-color 0.2s;

  ${({size}) => size === 'normal' 
    ? css`
      width: 60px;
      font: 21px/1 Merriweather, serif;    
    ` : css`
      width: 40px;
      font: 16px/1 Merriweather, serif;
    `
  };

  font-style: italic;
  
  &:focus {
    outline: none;
    border-color: #95bb9e;
  }
  
  &::-webkit-inner-spin-button,
  &::-webkit-outer-spin-button {
    opacity: 1;
  }
`

const AddToCart = ({
  good,
  activeCatalogType,
  currentUser,
  quantityInCart,
  setQuantityInCart,
  layout = 'normal'
}) => {
  const size = layout === 'normal' ? 'normal' : 'small'

  const {price, buyRestrictionMsg, availableQuantity} = good
  const discount = calcDiscount(activeCatalogType, good, currentUser)

  let buySection = null
  if (currentUser.stats.walletsBlocked) {
    buySection = <Restriction layout={layout}>Покупка невозможна из-за блокировки кошельков</Restriction>
  } else if (buyRestrictionMsg && availableQuantity <= 0) {
    buySection = <Restriction layout={layout}>
      <RestrictionTitle size={size}>Условия покупки:</RestrictionTitle>
      <div dangerouslySetInnerHTML={{__html: buyRestrictionMsg}}/>
    </Restriction>
  } else if (quantityInCart > 0) {
    buySection = <QuantityControl size={size}>
      В корзине:
      <Input
        value={quantityInCart}
        onChange={event => setQuantityInCart(event.target.value)}
        type="number"
        min="0"
        step="1"
        max={good.availableQuantity}
        size={size}
      />
    </QuantityControl>
  } else {
    buySection = <Button clickHandler={() => setQuantityInCart(1)} size={size}>Добавить в корзину</Button>
  }

  return <Root layout={layout}>
    <PriceBin layout={layout}>
      <PriceAndIcons>
        {layout !== 'normal' && <GoodPropsIcons good={good} currentUser={currentUser} activeCatalogType={activeCatalogType}/>}
        <GoodPrice price={price} discount={discount} currency={activeCatalogType.currency} size={size} priceWidth={layout === 'small' ? 90 : null}/>
      </PriceAndIcons>
    </PriceBin>
    <BuySectionBin layout={layout}>
      {buySection}
    </BuySectionBin>
  </Root>
}

export default AddToCart



